
export const buyCar = {
    event: "buy_car",
    eventCategory: "homepage_dweb",
    eventAction: "buy_cars",
    eventLabel: "city_page"
};

export const scrollStoresAndParkingYards = {
    event: "scroll_stores_and_parking_yards",
    eventCategory: "homepage",
    eventAction: "branch_widget_scrolled",
    eventLabel: "city_page"
};

export const getCarPriceBottom = {
    eventCategory: "homepage_dweb",
    event: "get_car_price_bottom",
    eventAction: "get_car_price_sticky_clicked"
};

export const popularCityTextClick = {
    event: "popular_city_text_click",
    eventCategory: "homepage_dweb",
    eventAction: "popular_city_clicked"
};
